import { render, staticRenderFns } from "./MerchantGoodsProfitStatistics.vue?vue&type=template&id=e673e60c&scoped=true"
import script from "./MerchantGoodsProfitStatistics.vue?vue&type=script&lang=js"
export * from "./MerchantGoodsProfitStatistics.vue?vue&type=script&lang=js"
import style0 from "./MerchantGoodsProfitStatistics.vue?vue&type=style&index=0&id=e673e60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e673e60c",
  null
  
)

export default component.exports